import React, { useEffect, useState } from 'react';
import { Input, useSelectCustomControl } from '@vtblife/uikit';
export const InputControl = ({ value, onChange, onReset, hasSuggestions }) => {
    const { toggle, opened, control } = useSelectCustomControl();
    const [isVisible, setIsVisible] = useState(false);
    const handleFocus = () => {
        setIsVisible(true);
    };
    const handleBlur = () => {
        setIsVisible(false);
    };
    useEffect(() => {
        if (!isVisible && opened) {
            toggle();
        }
        else if (hasSuggestions && isVisible && !opened) {
            toggle();
        }
        else if (!hasSuggestions && opened) {
            toggle();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasSuggestions, opened, isVisible]);
    return (React.createElement("div", { ref: control },
        React.createElement(Input, { size: "m", value: value, placeholder: "\u0413\u043E\u0440\u043E\u0434", dataTest: "select-region-quiz-input", onChange: onChange, onReset: onReset, onBlur: handleBlur, onFocus: handleFocus })));
};
//# sourceMappingURL=input-control.js.map